import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectNewSessionPlaceholder } from "store/calendarSidebarSlice";
import { isFullDay } from "../utils/is-full-day";
import { NormalizedCalendarEvent } from "./use-normalized-events";

const useNormalizedNewSessionPlaceholder = () => {
  const newSessionPlaceholder = useSelector(selectNewSessionPlaceholder);

  const sessionPlaceholderNormalized: NormalizedCalendarEvent | null = useMemo(
    () =>
      newSessionPlaceholder
        ? {
            type: "placeholder",
            item: newSessionPlaceholder,
            startISO: newSessionPlaceholder.appointment_start,
            endISO: newSessionPlaceholder.appointment_end,
            id: "new-session-placeholder",
            isFullDay: isFullDay(
              newSessionPlaceholder.appointment_start,
              newSessionPlaceholder.appointment_end,
            ),
          }
        : null,
    [newSessionPlaceholder],
  );

  return sessionPlaceholderNormalized;
};

export default useNormalizedNewSessionPlaceholder;
